import { render, staticRenderFns } from "./GestionTicketsPostventa.vue?vue&type=template&id=31cf7ec4&scoped=true"
import script from "./GestionTicketsPostventa.vue?vue&type=script&lang=js"
export * from "./GestionTicketsPostventa.vue?vue&type=script&lang=js"
import style0 from "./GestionTicketsPostventa.vue?vue&type=style&index=0&id=31cf7ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cf7ec4",
  null
  
)

export default component.exports